import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/code-segment';

import '../styles/install.less';


export default new Mosaic({
    name: 'install-page',
    view() {
        return html`
        <navigation-bar></navigation-bar>

        <h1 class='section-title' tabindex='0'>💻 Installation</h1>
        <p class='section-text' tabindex='0'>
            Mosaic is extremely easy to install and get started with. Because it uses
            built-in JavaScript features, there is no need to use a compiler like Babel.
        </p>
        <p class='section-text' tabindex='0'>
            You can either download Mosaic using the script tag or the following npm command.
            This tutorial will be using the script tag.
        </p>

        <code-segment type='BASH'>
            npm install --save mosaic-framework
        </code-segment>
        <code-segment>
            ${"<script src='https://unpkg.com/mosaic-framework@latest/dist/index.js'></script>"}
        </code-segment>

        <p class='section-text' tabindex='0'>
            Once you've included the package in your project, it is time to start writing Mosaic
            code! All you need to get started when using the script tag is an "index.html" file
            and an "index.js" file.
        </p>
        
        <iframe width="100%" height="300" src="//jsfiddle.net/97hdo3r5/1/embedded/js,html,result/" allowfullscreen="allowfullscreen" allowpaymentrequest frameborder="0"></iframe>
        
        <p class='section-text' tabindex='0'>
            ⭐️That's all that it takes to get started with Mosaic! ⭐ ️
        </p>

        <app-footer></app-footer>
        `
    }
})